module.exports = __webpack_public_path__ + "static/media/29ADMSPC3.f26f80e3.jpg";